import { useSnackbar } from "notistack";
import type { FC } from "react";
import DownloadPdfButtonWithYear from "../../components/downloadFileButton/DownloadPdfButtonWithYear";
import { getProductPricesPdf } from "./productsApi";

interface Props {
  readonly productId: string;
  readonly productName: string;
  readonly useDynamicPrices: boolean;
}

const DownloadProductPricesPdfButton: FC<Props> = ({ productId, useDynamicPrices, productName }) => {
  const { enqueueSnackbar } = useSnackbar();
  const options = [
    { name: "Ceny zakupu", apiDefinition: (year: number) => getProductPricesPdf(productId, "purchase", year) },
    { name: "Ceny sprzedaży", apiDefinition: (year: number) => getProductPricesPdf(productId, "selling", year) },
    { name: "Ceny FIT", apiDefinition: (year: number) => getProductPricesPdf(productId, "fit", year) },
  ];
  return (
    <DownloadPdfButtonWithYear
      buttonText="Pobierz PDF z cennikiem"
      options={options}
      useDynamicPrices={useDynamicPrices}
      onError={() => enqueueSnackbar("Nie udało się pobrać pliku PDF z cenami", { variant: "error" })}
      filename={(year) => `${productName} - ${year}.pdf`}
    />
  );
};

export default DownloadProductPricesPdfButton;
